module.exports = __webpack_public_path__ + "wj51c-small.png?46823f762036385225982af7ff6b6cff";